import { useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { apiHomeTodoList } from '@/api/home';
import { IHomeTodoResponse } from '@/api/typings/home';
import { useStore } from '@/store';

export const useTodoData = () => {
  const [loading, setLoading] = useState(false);
  const [todo, setTodo] = useState<IHomeTodoResponse | undefined>(undefined);
  const { setTodoCount } = useStore('user');

  const fetchTodoData = useMemoizedFn(async () => {
    try {
      setLoading(true);
      const todoData = await apiHomeTodoList();
      setTodo(todoData);

      // 计算待办总数
      const totalCount =
        (todoData?.perTodo?.length || 0) +
        (todoData?.applyTodo?.length || 0) +
        (todoData?.leaveTodo?.length || 0) +
        (todoData?.outBusinessTodo?.length || 0) +
        (todoData?.outOfficialTodo?.length || 0) +
        (todoData?.entryTodo?.length || 0) +
        (todoData?.overtimeTodo?.length || 0) +
        (todoData?.replaceCardTodo?.length || 0) +
        (todoData?.recruitTodo?.length || 0) +
        (todoData?.positionApplyTodo?.length || 0) +
        (todoData?.salaryIncreaseTodo?.length || 0) +
        (todoData?.trialTodo?.length || 0) +
        (todoData?.shiftApplyTodo?.length || 0);

      setTodoCount(totalCount);
      return todoData;
    } catch (e) {
      console.error('获取待办数据失败:', e);
      throw e;
    } finally {
      setLoading(false);
    }
  });

  return {
    loading,
    todo,
    fetchTodoData,
  };
};
